import type { ReactNode } from 'react';

interface CardProps {
  className?: string;
  children: ReactNode;
  /** Cartão maior (rounded-[22px]) — para destaques. */
  grande?: boolean;
}

// Superfície branca do app: rounded-[18px], sombra discreta, sem borda colorida.
export default function Card({ className = '', children, grande = false }: CardProps) {
  return (
    <div
      className={`bg-background-50 shadow-pcard ${grande ? 'rounded-[22px]' : 'rounded-[18px]'} ${className}`}
    >
      {children}
    </div>
  );
}